import React from 'react';
import cx from 'classnames';

export interface HorizontalDividerProps {
  className?: string;
}

export function HorizontalDivider({ className }: HorizontalDividerProps) {
  return (
    <span
      className={cx(className, 'block w-full h-[1px] v2-bg-neutral-300 my-4')}
    />
  );
}
